// Client entry referenced from src/index.html. Imports `./i18n` for its
// init side effect before the React tree mounts so first paint already
// has translations available.
// The app stylesheet first: it declares Tailwind's layer order (theme, base, components, utilities). CSS that a
// feature imports (e.g. usage/usage.css) is bundled in import order; any `@layer` seen before this one would fix
// the order early and let preflight's `* { padding: 0 }` beat book.css (prod Pages 9d35caf7).
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { App } from "./App";
const elem = document.getElementById("root");
if (!elem) throw new Error("#root not found in index.html");
const app = <StrictMode>
		<App />
	</StrictMode>;
if (import.meta.hot) {
  let root = import.meta.hot.data.root;
  if (!root) {
    root = createRoot(elem);
    import.meta.hot.data.root = root;
  }
  root.render(app);
} else {
  createRoot(elem).render(app);
}